var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-wrap"},[_c('span',{staticClass:"line"}),_c('span',{staticClass:"dot"}),_c('span',{staticClass:"title"},[_vm._t("default")],2),_c('span',{staticClass:"dot"}),_c('span',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }